import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { MarketingFooter } from './components/footer/MarketingFooter'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="flex min-h-screen flex-col bg-white text-gray-900 dark:bg-slate-950 dark:text-slate-100">
        <div className="flex-1">
          <AppRoutes />
        </div>
        <MarketingFooter />
      </div>
    </BrowserRouter>
  )
}

export default App